import React, { useRef } from 'react';
import { getText } from '@storebrand-digital/fms-translations';

import DocumentCardItem from './Document.CardItem';
import DocumentCardSkeleton from './Document.CardSkeleton';
import { useDocumentsWithPagination } from './hooks';
import { AlertInline } from '@storebrand-digital/pretzel';
import { DocumentCardListHead } from './DocumentCardListHead';
import styles from './Document.CardList.module.css';

function DocumentCardList() {
  const { data, isError, isLoading, isFetching } = useDocumentsWithPagination();
  const lastRowCount = useRef(15);

  if (isLoading || isFetching) {
    return (
      <>
        <DocumentCardListHead />
        <div className={styles.documentCardListContainer}>
          {Array(lastRowCount.current)
            .fill('')
            .map((_, index) => (
              <DocumentCardSkeleton key={`card-skeleton-${index}`} />
            ))}
        </div>
      </>
    );
  }

  if (isError) {
    lastRowCount.current = 1;
    return (
      <div className={styles.documentCardListContainer}>
        <AlertInline
          heading={getText('error.table.fetchDocuments')}
          variant="error"
          role="status"
        />
      </div>
    );
  }

  if (data?.documents?.length === 0) {
    lastRowCount.current = 1;
    return (
      <div className={styles.documentCardListContainer}>
        <AlertInline
          heading={getText('documents.notfound')}
          variant="info-subtle"
          role="status"
        />
      </div>
    );
  }

  lastRowCount.current = data?.documents.length as number;
  return (
    <>
      <DocumentCardListHead />
      <div className={styles.documentCardListContainer}>
        {data?.documents?.map((document) => (
          <DocumentCardItem key={document.id} {...document} />
        ))}
      </div>
    </>
  );
}

export default DocumentCardList;
